import { PackageNameEnum } from '@electricjs/core_entity-client';

import { useAppSelector } from '@/redux/store';

/**
 * Hook to determine if the current organization has a Pro plan.
 * @returns {boolean} True if the organization has a Pro plan, false otherwise.
 */
export const useHasProPlan = (): boolean => {
  const packages =
    useAppSelector(state => state.loggedUser?.organizationPackages) || [];

  return packages.some(plan => plan.package.name === PackageNameEnum.Pro);
};
